'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var getThemeProp = require('../utils/getThemeProp.js');
require('../utils/colors.js');
require('../utils/dates.js');
require('../utils/numbers.js');
require('../utils/PrintComponentGenerator/PrintComponentGenerator.js');
require('../utils/strings.js');
require('../utils/infiniteScrollCheckStateManager/infiniteScrollCheckStateManager.js');
require('../utils/pairedTableComponentGenerator/pairedTableComponentGenerator.js');
require('../utils/safeFetch.js');
require('../utils/dom.js');
var Tooltip = _interopDefault(require('@material-ui/core/Tooltip'));

var StyledTooltip = styled__default(Tooltip)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  font-family: ", ";\n  font-size: 0.8rem;\n  color: ", ";\n\n  svg {\n    margin-right: 0.5rem;\n    height: 1rem;\n    width: 1rem;\n  }\n"], ["\n  font-family: ", ";\n  font-size: 0.8rem;\n  color: ", ";\n\n  svg {\n    margin-right: 0.5rem;\n    height: 1rem;\n    width: 1rem;\n  }\n"])), getThemeProp('typography.fontFamily'), getThemeProp('palette.primary.main'));
var templateObject_1;

module.exports = StyledTooltip;
